/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import httpClient from './httpClient';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Put = (endpoint, params) => {
  const queryClient = useQueryClient();

  const putQueryFunction = ({ id, ...rest }) => new Promise((resolve, reject) => {
    httpClient.put(`${endpoint}/${id}/`, { ...rest })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });

  return useMutation({
    mutationFn: putQueryFunction,
    // Refetch only after a successful mutation (a failed write changed nothing).
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [endpoint] });
    },
  });
};

export default Put;
